import { Link } from 'react-router-dom';
import { events } from '@/mocks/events';
import { formatHeat } from '@/utils/format';

interface RelatedEventsProps {
  ids: string[];
}

export default function RelatedEvents({ ids }: RelatedEventsProps) {
  const list = events.filter((item) => ids.includes(item.id)).slice(0, 4);
  if (list.length === 0) return null;

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {list.map((item) => (
        <Link
          key={item.id}
          to={`/timeline/${item.id}`}
          className="group flex gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
        >
          <div className="h-16 w-20 shrink-0 overflow-hidden rounded-md">
            <img
              src={item.cover}
              alt={`${item.title} - 蝌蚪吃瓜相关事件`}
              title={`${item.title} - 蝌蚪吃瓜`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="flex min-w-0 flex-1 flex-col justify-center">
            <h4 className="line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
              {item.title}
            </h4>
            <div className="mt-1 flex items-center gap-2 font-label text-xs text-foreground-500">
              <span>{item.categoryName}</span>
              <span className="flex items-center gap-0.5">
                <i className="ri-fire-line text-primary-500" />
                {formatHeat(item.heat)}
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}